/* app/js/src/components/common/iDropdown/iDropdown.component.scss */
div section ul {
  max-width: 30vw;
  z-index: 9;
  max-height: 40vh;
  overflow-y: scroll;
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  list-style-type: none;
  padding: 0;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
div label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
div section {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
div section:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
div section::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div section:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div section::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div section:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div section.ng-invalid.ng-dirty,
div section.ng-invalid.ng-touched {
  border-color: #ef5350;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  margin-bottom: 20px;
}
div label {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
div section {
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
  position: relative;
}
div section span {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #232f3a;
  height: inherit;
  cursor: pointer;
}
div section span i {
  display: block;
  font-style: normal;
}
div section span i.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
div section span svg {
  display: block;
}
div section ul {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
div section ul.dropdown-list {
  bottom: auto;
  top: 16px;
}
div section ul li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
div section ul li i {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: 10px;
  width: 10px;
  height: 12px;
  margin-right: 9px;
  margin-left: 12px;
}
div section ul li i svg {
  max-width: 10px;
  width: 10px;
  height: 12px;
}
div section ul li i svg path {
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  -ms-transform: translateX(-10px);
  -webkit-transform: translateX(-10px);
  transform: translateX(-10px);
  opacity: 0;
  fill: #232f3a;
}
div section ul li i.multiple {
  position: relative;
}
div section ul li i.multiple::before {
  content: " ";
  border: 1px solid #e1e6eb;
  height: 12px;
  width: 12px;
  position: absolute;
  top: -2px;
  left: -2px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div section ul li span {
  -webkit-flex: 12 0 0;
  -ms-flex: 12 0 0;
  flex: 12 0 0;
  display: block;
}
div section ul li:hover {
  background-color: #eef2f6;
}
div section ul li:hover i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 0.5;
}
div section ul li.selected i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 1;
}
div section ul li.selected i.multiple::before {
  border-color: #879baf;
}
/*# sourceMappingURL=iDropdown.component.css.map */
